import { Component } from "@angular/core";

@Component({
  selector: "account-home",
  templateUrl: "./accounthome.component.html",
})
export class AccountHomeComponent {
}
